<template>
  <div>

    <!-- Diary date -->
    <diary-date-select v-model="fields.diaryDate"></diary-date-select>
    <input type="hidden" name="diary_date" :value="fields.diaryDate">

    <template v-if="fields.diaryDate !== fields.currentDiaryDate">
      <!-- Diary date change reason -->
      <select v-model="fields.ddReasonId" name="dd_reason_id" class="form-control mt-2">
        <option value="">Select the change reason ...</option>
        <option v-for="(reasonText, reasonId) in ddChangeReasons" :value="reasonId">{{ reasonText }}</option>
      </select>
      <!-- Custom diary date change reason text -->
      <textarea v-if="showCustomDDReasonField" v-model="fields.ddReason" name="dd_reason"
        class="form-control mt-2" rows="2" placeholder="Enter the reason for changing the diary date...">
      </textarea>
    </template>

  </div>
</template>

<script>
import DiaryDateSelect from "../../DiaryDateSelect.vue";

export default {
  components: {'diary-date-select': DiaryDateSelect},

  props: {
    initialDiaryDate: {type: String, default: ''},
    ddReasons: {type: Object, default: () => {}},
  },

  data() {
    return {
      fields: {
        diaryDate: this.initialDiaryDate,
        currentDiaryDate: this.initialDiaryDate,
        ddReasonId: '',
        ddReason: '',
      },
    }
  },

  computed: {

    ddChangeReasons() {
      let reasons = this.ddReasons;
      reasons[-1] = 'Other';
      return reasons;
    },

    showCustomDDReasonField() {
      return (this.fields.ddReasonId === -1) || (this.fields.ddReasonId === '-1');
    },

  }
}
</script>
